async function fillRetailers(retailers) {
  await fetch(retailers.getAttribute("data-url"))
    .then((response) => response.json())
    .then((data) => {
      let content = "";
      const items = data.sheet1;
      const template = Handlebars.compile(`
              <div class="retailer_container">
                  <div class="title_container">
                    <h3 class="store">{{store}} {{#if region}}<span class="region">({{region}})</span>{{/if}}</h3>
                    {{#if market}}
                      <span class="country-logo country-flags country-flags--{{market}}"></span>
                    {{/if}}
                  </div>
                  {{#if address}}
                      <div>{{address}}</div>
                  {{/if}}
                  {{#if website}}
                      <div class="website"><a href="https://{{website}}">{{website}}</a></div>
                  {{/if}}
                  {{#if contact}}
                      <div class="contact">{{contact}}</div>
                  {{/if}}
              </div>
              `);

      items.forEach((item) => {
        content += template(item);
      });

      retailers.innerHTML = content;
    })
    .catch((error) => console.error("Error:", error));
}

const initRetailers = () => {
  const retailersContainers = document.getElementsByClassName("retailers");
  for (var i = 0, max = retailersContainers.length; i < max; i++) {
    fillRetailers(retailersContainers[i]);
  }
};
